var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPanelShowRight = function SvgPanelShowRight(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "panel_show_right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 1.5,
    transform: "translate(11.998427, 8.000000) scale(-1, 1) rotate(90.000000) translate(-11.998427, -8.000000) ",
    x: 6.74842712,
    y: 5.75,
    width: 10.5,
    height: 4.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    stroke: "#000000",
    fill: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(3.466447, 8.000000) scale(-1, 1) rotate(90.000000) translate(-3.466447, -8.000000) ",
    points: "3.46644661 6 7.46644661 10 -0.533553391 10"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPanelShowRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/panel_show_right.931b96c4f6504bfbbe0f81d2f9a08931.svg";